import React, { useCallback, useEffect } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Card } from "react-bootstrap";
import { faPlusSquare } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { openCustomModal, closeCustomModal } from "views/lib/components/modals";
import { getList, remove, add } from "actions/scooter/parking/actions";
import ScooterParkingMap from "./map";
import CreateNewParking from "./create-new-parking";
import FilterHeader from "../../../lib/components/filter/filter-header";

const googleMapURL = "https://maps.googleapis.com/maps/api/js?key=AIzaSyCC-gpzzG6hcmAyagvaYCc23KAy4rIkv2A&v=3.exp&libraries=geometry,drawing,places,visualization";

const ScooterParking = ({
                          list,
                          getList,
                          add,
                          remove,
                          openCustomModal,
                          closeCustomModal,
                        }) => {
  useEffect(() => {
    getList();
  }, [getList]);

  const handleAdd = () => {
    const modalObj = {
      id: "remove-scooter-parking",
      header: "Create Parking",
      handleClose: () => closeCustomModal(modalObj),
      modalSettings: {
        size: "md",
        style: {
          top: 20,
          width: "calc(100% - 40px)",
        }
      },
      children: <CreateNewParking onCancel={() => closeCustomModal(modalObj)} onAdd={(data) => {
        add({
          active: data.active,
          location: {
            latitude: data.latitude,
            longitude: data.longitude,
          }
        }, () => closeCustomModal(modalObj));
        getList();
      }}/>
    };
    openCustomModal(modalObj);
  };

  const handleClick = useCallback((item) => {
    const modalObj = {
      id: "remove-scooter-parking",
      header: "Parking remove",
      handleClose: () => closeCustomModal(modalObj),
      modalSettings: {
        size: "sm",
        style: {
          width: 400
        }
      },
      children: (
        <div>
          <div className="text-center mb-4">
            <div>You are going to remove <b>{item.active ? "active" : "inactive"}</b> parking</div>
            <b>{item.id}</b>
          </div>
          <div className="d-flex justify-content-between">
            <button className="btn btn-sm btn-success" onClick={() => closeCustomModal(modalObj)}>
              Cancel
            </button>
            <button className="btn btn-sm btn-danger" onClick={() => {
              closeCustomModal(modalObj);
              remove(item.id, getList);
            }}>
              Remove
            </button>
          </div>
        </div>
      )
    };
    openCustomModal(modalObj);
  }, [getList, remove, openCustomModal, closeCustomModal]);

  return (
    <div className="w-100 p-2">
      <div className="filters">
        <Card className="w-100 mb-2 rounded-0">
          <FilterHeader
            title={
              <div className="d-flex">
                <div>Parking</div>
                <div>
                  <button
                    className="btn btn-sm btn-success ml-2"
                    onClick={handleAdd}
                    title="Add new zone"
                  >
                    <FontAwesomeIcon icon={faPlusSquare}/>
                  </button>
                </div>
              </div>
            }
            totalCount={list.length}
            onToggle={() => null}
            isOpen={false}
            noExpand={true}
          />
        </Card>
      </div>
      <div style={{
        height: "calc(100vh - 140px)"
      }}>
        <ScooterParkingMap
          places={list}
          googleMapURL={googleMapURL}
          loadingElement={<div style={{ height: "100%" }}/>}
          containerElement={<div style={{ height: "100%" }}/>}
          mapElement={<div style={{ height: "100%" }}/>}
          handleClick={handleClick}
        />
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  list: state.scooterParking.list,
});

const mapStateToDispatch = dispatch => ({
  openCustomModal: bindActionCreators(openCustomModal, dispatch),
  closeCustomModal: bindActionCreators(closeCustomModal, dispatch),

  getList: bindActionCreators(getList, dispatch),
  remove: bindActionCreators(remove, dispatch),
  add: bindActionCreators(add, dispatch),
});

export default connect(
  mapStateToProps,
  mapStateToDispatch
)(ScooterParking);



// WEBPACK FOOTER //
// ./src/views/pages/scooter/parking/index.js